import { IOperationType } from "./internals";
import { getElementMeta } from "./schema";
import { deleteFromContent, formatContent, getElementRangeByPath, insertIntoContent, legalizeContent, sliceContent, unwrapContent, wrapContent, } from "./utils";
export const applyOperation = (content, op) => {
    switch (op.type) {
        case IOperationType.INSERT: {
            return insertIntoContent(content, op.offset, op.content);
        }
        case IOperationType.DELETE: {
            return deleteFromContent(content, op.offset, op.offset + op.length);
        }
        case IOperationType.REPLACE: {
            deleteFromContent(content, op.offset, op.offset + op.length);
            insertIntoContent(content, op.offset, op.content);
            return;
        }
        case IOperationType.FORMAT: {
            return formatContent(content, op.offset, op.offset + op.length, op.format);
        }
        case IOperationType.WRAP: {
            return wrapContent(content, op.offset, op.offset + op.length, op.tag, op.props);
        }
        case IOperationType.UNWRAP: {
            return unwrapContent(content, op.path);
        }
    }
};
export const applyOperationToCursor = (content, cursor, op, prefer) => {
    const insert = (offset, length) => {
        if (cursor === offset) {
            if (prefer === "left") {
                // DO NOTHING
            }
            else {
                cursor += length;
            }
        }
        else if (cursor > offset) {
            cursor += length;
        }
        else {
            // DO NOTHING
        }
    };
    const delete_ = (offset, length) => {
        if (cursor > offset) {
            cursor = Math.max(cursor - length, offset);
        }
        else {
            // DO NOTHING
        }
    };
    const replace = (offset, oldLength, newLength) => {
        if (oldLength === 0 && newLength === 0) {
            return;
        }
        if (oldLength === 0) {
            return insert(offset, newLength);
        }
        if (newLength === 0) {
            return delete_(offset, oldLength);
        }
        if (cursor <= offset) {
            return;
        }
        if (cursor >= offset + oldLength) {
            cursor += newLength - oldLength;
        }
        else if (cursor > offset && cursor < offset + oldLength) {
            cursor = offset;
        }
    };
    switch (op.type) {
        case IOperationType.INSERT: {
            insert(op.offset, op.content.length);
            break;
        }
        case IOperationType.DELETE: {
            delete_(op.offset, op.length);
            break;
        }
        case IOperationType.REPLACE: {
            replace(op.offset, op.length, op.content.length);
            break;
        }
        case IOperationType.WRAP: {
            let piece = sliceContent(content, op.offset, op.offset + op.length);
            piece = legalizeContent(piece, op.tag);
            const shift = piece.length - op.length;
            if (shift < 0) {
                delete_(op.offset, Math.abs(shift));
            }
            else if (shift > 0) {
                insert(op.offset, shift);
            }
            if (getElementMeta(op.tag).hasBoundary) {
                insert(op.offset, 1);
                insert(op.offset + op.length + shift + 1, 1);
            }
            break;
        }
        case IOperationType.UNWRAP: {
            if (getElementMeta(op.tag).hasBoundary) {
                const [startOffset, endOffset] = getElementRangeByPath(content, op.path);
                delete_(startOffset, 1);
                delete_(endOffset - 2, 1);
            }
            break;
        }
        default: {
            // DO NOTHING
            break;
        }
    }
    return cursor;
};
